import script from "./messagelist.vue?vue&type=script&setup=true&lang=js"
export * from "./messagelist.vue?vue&type=script&setup=true&lang=js"

import "./messagelist.vue?vue&type=style&index=0&id=0c706088&scoped=true&lang=scss"
import "./messagelist.vue?vue&type=style&index=1&id=0c706088&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c706088"]])

export default __exports__